import {
  EcommercePerformanceAction,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_FAIL,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_SUCCESS,
  LoadEcommercePerformanceReportOrders, LoadEcommercePerformanceReportOrdersFail,
  LoadEcommercePerformanceReportOrdersSuccess
} from "../actions";


export interface IEcommercePerformanceReportOrdersEntityState {
  ordersData: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePerformanceReportOrdersState {
  entities: { [websiteId: number]: IEcommercePerformanceReportOrdersEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePerformanceReportOrdersState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePerformanceReportOrdersState = initialState, action: EcommercePerformanceAction): IEcommercePerformanceReportOrdersState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS:
      payload = (<LoadEcommercePerformanceReportOrders>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_SUCCESS:
      payload = (<LoadEcommercePerformanceReportOrdersSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            ordersData: payload.ordersData,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_FAIL:
      payload = (<LoadEcommercePerformanceReportOrdersFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
